import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsTaxIdWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_TAX_ID;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-tax-id-wut.js.map